export class Inscricao {
  anoVestibular: number;
  aprovado: any; // TODO: qual o tipo desse param??
  classificacao: any; // TODO: qual o tipo desse param??
  codigoCampus: string;
  codigoCurso: string;
  codigoCursoAlternativa: number;
  codigoVestibular: number;
  dataLiberacaoCartao: any; // TODO: qual o tipo desse param??
  descricaoPredio: string;
  diaVestibular: number;
  dataInscricaoFinal: number;
  horaFinal: string;
  horaInicial: string;
  inscricao: string;
  nomeCampus: string;
  nomeCampusAgendamento: string;
  nomeCurso: string;
  nomeSala: string;
  nomeVestibular: string;
  nota: any; // TODO: qual o tipo desse param??
  notaRedacao: any; // TODO: qual o tipo desse param??
  prova: string;
  podeEmitirSegundaVia: string; // S: sim, N: não
  parcelamentoSelected: any;
  siglaVestibular: string;
  situacaoBoleto: string;
  situacaoFoto: string;
  tipoVestibular: string;
  turnoCurso: string;
  valorBoleto: number;
  ativo: boolean; // dado temporário
  designacaoMotora: string; // S: canhoto, N: destro
  descricaoPne: string; // [não, visual, motora, auditiva, outros]
  vestibularEncerrado: string;
  anoEnem: number;
  pontuacaoEnem: number;

  static dadosInscricaoParaInscricaoAdapter(dadosInscricao: any) {
    if (dadosInscricao) {
      const adapter = {
        inscricao: dadosInscricao.agendamento.numeroInscricao,
        valorBoleto: dadosInscricao.vestibular.valorInscricao,
      };
      return new Inscricao(adapter);
    }
  }

  static sanitizarDesignacaoMotora(designacaoMotora: string): string {
    let tmp = designacaoMotora;
    if (tmp !== 'S') {
      tmp = 'N';
    }
    return tmp;
  }

  static sanitizarDescricaoPne(descricaoPne: string): string {
    let tmp = descricaoPne;
    if (tmp) {
      tmp = tmp.toLowerCase();
      if (tmp === 'não' || tmp === 'nao') {
        tmp = undefined;
      }
    } else {
      tmp = undefined;
    }
    return tmp;
  }

  static sanitizarVestibularEncerrado(vestibularEncerrado: string): string {
    let tmp = vestibularEncerrado;
    if (tmp) {
      tmp = tmp.toLowerCase();
      if (tmp === 'não' || tmp === 'nao' || tmp === 'n') {
        tmp = undefined;
      }
    } else {
      tmp = undefined;
    }

    return tmp;
  }

  get reagendavel() {
    return !this.vestibularEncerrado;
  }

  get opcaoDeCursoAlteravel() {
    return !this.vestibularEncerrado;
  }

  constructor(args) {
    Object.assign(this, args);
    this.designacaoMotora = Inscricao.sanitizarDesignacaoMotora(this.designacaoMotora);
    this.descricaoPne = Inscricao.sanitizarDescricaoPne(this.descricaoPne);
    this.vestibularEncerrado = Inscricao.sanitizarVestibularEncerrado(this.vestibularEncerrado);
  }
}
